<!--华伟刀闸列表查询-->
<template>
	<treeBody>
		<!--左边-->
		<virtualDeviceTree slot="tree" :dataList="deviceList" @checkItem="nowDevice = $event" :autoSelectMethod='autoSelectMethod'></virtualDeviceTree>
		<!--右边-->
		<div class="monreportRigth" slot="body">
			<div class="buttonLine">
				<multipleSelection title="变量类型" nameKey="name" :list='apptypeGroups' @checkDataList="nowApptypeGroups = $event"
				 :autoCheckIdList="nowSelectAppTypeGroupIds"></multipleSelection>
				<datePicker class="marginLeft" :initDate='bgDate' @checkDate="bgDate = $event" dateType="dateTime"></datePicker>
				<datePicker class="marginLeft" :initDate='endDate' @checkDate="endDate = $event" dateType="dateTime"></datePicker>
				<iconButton icoName="wedoButton/search.png" buttonText="查看" @buttonClick="searchKnifegate"></iconButton>
			</div>
			<!--表格显示数据-->
			<infoList ref="infoList" style="height: calc(100% - 50px);" :columns='columns' :dataList="dataList" :pageLen='pageLen'
			 :totalSize="dataList.length" :fillAll="true" :showIndex='false'></infoList>
		</div>
	</treeBody>
</template>

<script>
	import treeBody from '@/components/module/slotModule/treeBody.vue'
	import virtualDeviceTree from '@/components/module/tree/virtualDeviceTree.vue'
	import multipleSelection from '@/components/module/selection/multipleSelection.vue'
	import datePicker from '@/components/module/datePicker/base/datePicker.vue'
	import iconButton from '@/components/module/universal/iconButton.vue'
	import dateButton from '@/components/module/universal/dateButton.vue'
	import infoList from '@/components/module/universal/infoList.vue'
	export default {
		components: {
			virtualDeviceTree,
			treeBody,
			multipleSelection,
			datePicker,
			iconButton,
			dateButton,
			infoList,
		},
		props: {},
		data() {
			return {
				deviceList: [],
				nowApptypeGroups: [], //当前选中的应用类型组
				bgDate: new Date('2018-11-01'),
				endDate: new Date(),
				nowSelectAppTypeGroupIds: [],
				nowDevice: undefined,
				columns: [{
					name: '监测点',
					key: 'variableName'
				}, {
					name: '开始时间',
					key: 'beginTime',
					format(item) {
						return new Date(item).formatByMillisecond('-')
					},
					weight:2
				}, {
					name: '持续时间(秒)',
					key: 'time'
				}, {
					name: '最大值(A)',
					key: 'max'
				},{
					name: '最小值(A)',
					key: 'min'
				}, {
					name: '有效值(A)',
					key: 'effective'
				}, {
					name: '操作',
					key: 'operating'
				}, {
					name: '额定值(A)',
					key: 'rating'
				}, {
					name: '是否正常',
					key: 'isOk'
				}, ],
				dataList: [],
				variableNameToBean: {}
			}
		},
		created() {
			debugPage = this
		},
		mounted() {
			//从静态资源中获取静态数
			this.deviceList = knifeGateCurveDefaultDeviceTree
			setTimeout(() => {
				this.searchKnifegate()
			}, 2000)
		},
		destroyed() {},
		computed: {
			variableList() {
				//当前选中的设备的选择的应用类型组的变量列表
				if (isempty(this.nowApptypeGroups)) {
					return []
				}
				var list = []
				for (var i = 0, len = this.nowApptypeGroups.length; i < len; i++) {
					var item = this.nowApptypeGroups[i]
					list.addAll(item.next)
				}
				return list
			},
			apptypeGroups() {
				if (this.nowDevice == undefined) {
					return []
				}
				return knifeGateCurveDefaultDeviceNoToVariableTree[this.nowDevice.no]
			},
			pageLen() {
				return this.dataList.length < 20 ? 20 : this.dataList.length
			},
		},
		watch: {
			apptypeGroups(nv, ov) {
				if (nv.length > 0) {
					this.nowSelectAppTypeGroupIds = [nv[0].id]
				} else {
					this.nowSelectAppTypeGroupIds = []
				}
			},
			variableList(nv, ov) {
				var variableNameToBean = {}
				for (var i = 0, len = nv.length; i < len; i++) {
					var item = nv[i]
					variableNameToBean[item.name] = item
				}
				this.variableNameToBean = variableNameToBean
			}
		},
		methods: {
			autoSelectMethod(item, index) {
				return item.type == 'virtualDevice'
			},
			selectBgDate(date) {
				this.bgDate = date
			},
			selectEndDate(date) {
				this.endDate = date
			},
			searchKnifegate() {
				if (isempty(this.variableList)) {
					//没变量，返回
					return
				}
				this.$api.knifegateApi.getDataList(this.variableList.map(item => item.name).join(","), this.bgDate.getTime(), this.endDate
					.getTime(), respon => {
						//处理一下结果
						var list = []
						eachObject(respon, (vList, key) => {
							var variable = this.variableNameToBean[key]
							for (var i = 0, len = vList.length; i < len; i++) {
								var item = vList[i]
								var dataList = item.dataList.split(',')
								//找最大值最小值
								var max = undefined
								var min = undefined
								for (var j = 0, lenj = dataList.length; j < lenj; j++) {
									var data = dataList[j]
									if (max == undefined || max < data) {
										max = data
									}
									if (min == undefined || min > data) {
										min = data
									}
								}
								item.max = max
								item.min = min
								item.effective = cutDigital(max / Math.sqrt(2), 3)
								item.name = key
								item.time = dataList.length
								item.rating = variable.rating
								item.isOk = variable.isOk
								delete item.dataList
								list.push(item)
							}
						})
						this.dataList = list
					})
			}
		}
	}
</script>

<style scoped>
	.marginLeft {
		margin: 0 10px;
	}

	.monreportRigth {
		width: 100%;
		height: 100%;
		overflow: hidden;
	}
</style>
